import React from "react";
import ListSelect from "./listSelect";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { COMMON_ALT, COMMON_WEB_PATH } from "../../constant";
import { Flex, Image, useColorModeValue } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import useCheckLogin from "../../hook/useCheckLogin";

const MobileSearch = ({ listHidden }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const dispatch = useDispatch();

  const { isLogin } = useCheckLogin();

  const { gamePlatform } = useParams();

  const iconBg = useColorModeValue("light.200", "dark.100");
  const searchBg = useColorModeValue("light.100", "#262D47");
  const searchText = useColorModeValue("#8E8E8E", "#9D9D9D");

  return (
    <Flex
      direction={`column`}
      gap="8px"
      //px="common-y"
      mb={{
        base: "0px",
        md: "0px",
      }}
      w="100%"
    >
      <Flex alignItems={`center`} gap="2.5px" height="44px">
        {" "}
        <Flex
          as={Link}
          alignItems={`center`}
          justifyContent={`center`}
          borderRadius={`7.5px`}
          width="100%"
          height="39px"
          // bgImage={"linear(to-b,#3D240B,#0C0500)"}
          // border="2px solid #FEF48F"
          bgImage={`url(${COMMON_WEB_PATH}/now888/signIn/input_bg.png)`}
          bgSize="100%100%"
          to="search"
        ></Flex>
        {window.roulettes_activity == 1 ? (
          <Link to={"n-roulette"}>
            <Flex
              alignItems={`center`}
              justifyContent={`center`}
              borderRadius={`10px`}
              width="39px"
              height="39px"
              bg={iconBg}
            >
              <Image
                src={`${COMMON_WEB_PATH}/common_image/EventListSelect/active_04.webp`}
                cursor={`pointer`}
                maxWidth={`39px`}
                borderRadius={`common`}
                className="animate-spin"
                alt={COMMON_ALT}
              />
            </Flex>
          </Link>
        ) : null}
        {window.check_in_activity == 1 ? (
          <Link to={"checkin"}>
            <Flex
              alignItems={`center`}
              justifyContent={`center`}
              borderRadius={`10px`}
              width="39px"
              height="39px"
              bg={iconBg}
            >
              <Image
                src={`${COMMON_WEB_PATH}/common_image/EventListSelect/active_07.webp`}
                cursor={`pointer`}
                maxWidth={`39px`}
                borderRadius={`common`}
                alt={COMMON_ALT}
              />
              {/* <Icon as={FaCalendarAlt} fontSize="xl" /> */}
            </Flex>
          </Link>
        ) : null}
        <Flex
          as={Link}
          to="casino-group"
          alignItems={`center`}
          justifyContent={`space-between`}
          gap="10px"
          //borderRadius={`10px`}
          height="100%"
          // bg={searchBg}
          //bgImage={`url('${COMMON_WEB_PATH}/FlyDragon/game_BG.webp')`}
          bgImage={{
            base: `url('${COMMON_WEB_PATH}/now888/button/ALL.png')`,
            md: `url('${COMMON_WEB_PATH}/now888/button/ALL.png')`,
          }}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100%100%"
          color={searchText}
          minW="80px"
          // py="5px"
          // shadow={`0px 1px 5px #9D9D9D`}
        ></Flex>
      </Flex>
      <>{listHidden || <ListSelect />}</>
    </Flex>
  );
};

export default MobileSearch;
